import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { paths } from '@low6-pickem/api-types';
import { apiClient } from '../api-client.config';

type UpdateGameRulesVersionRequest = NonNullable<
  paths['/api/admin/pickems/game-rules/{id}']['put']['requestBody']
>['content']['application/json'];

type UpdateGameRulesVersionDto = UpdateGameRulesVersionRequest & { id: string };

export const updatePickemGameRulesVersion = ({ id, ...data }: UpdateGameRulesVersionDto) =>
  apiClient.put('/api/admin/pickems/game-rules/{id}', data, { pathParams: { id } });

export const useUpdatePickemGameRulesVersionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updatePickemGameRulesVersion,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pickem-game-rules'] });
    },
  });
};
